import { render, staticRenderFns } from "./MarketReport.vue?vue&type=template&id=6dfe7a74"
import script from "./MarketReport.vue?vue&type=script&lang=js"
export * from "./MarketReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports